import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'

export function useIsSafeURL() {
    const { getConfigByName } = useRemoteConfig()

    function isSafeURL(url: string): boolean {
        const ALLOWED_DOMAINS = (getConfigByName('AUTH_ALLOWED_DOMAINS') as unknown) as string[]

        try {
            const parsedUrl = new URL(url)

            // Verificar se o protocolo é seguro (apenas http e https são aceitos)
            if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
                return false
            }

            // domínio explicitamente na lista de permitidos vinda do firebase
            const verifyWithAllowedDomain = ALLOWED_DOMAINS.some(
                domain =>
                    parsedUrl.hostname === domain ||
                    parsedUrl.hostname.endsWith(`.${domain}`) ||
                    parsedUrl.hostname.startsWith(domain) ||
                    url.startsWith(domain),
            )

            !verifyWithAllowedDomain && console.error('URL não consta na lista de URLs seguras para redirecionamentos externos:', url)

            return verifyWithAllowedDomain
        } catch {
            console.error('Erro ao analisar a URL:', url)
            return false
        }
    }

    return {
        isSafeURL,
    }
}
